import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import {
  AppConfigService,
  AppTokenService,
  AuthAccessTokenDetails,
  OauthAEMConfig,
  OAuthFeatureConfig,
  UserDataService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { Observable } from 'rxjs';
import { concatMap, shareReplay, switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AppAuthTokenService {
  private _authConfigJson$!: Observable<OauthAEMConfig>;

  constructor(
    private userData: UserDataService,
    private appToken: AppTokenService,
    private http: HttpClient,
    private appConfig: AppConfigService,
    @Optional()
    @Inject('OAUTH_FEATURE_CONFIG')
    private _oAuthConfig: OAuthFeatureConfig
  ) {}

  getToken(): Observable<AuthAccessTokenDetails> {
    return this.getAuthConfigContent().pipe(
      concatMap((authConfig: OauthAEMConfig) =>
        this.appToken.getAppTokenWithParams(
          authConfig.CLIENT_ID_VALUE,
          authConfig.SCOPE_VALUE
        )
      )
    );
  }

  private getAuthConfigContent(): Observable<OauthAEMConfig> {
    if (!this._authConfigJson$) {
      if (this._oAuthConfig?.app && this._oAuthConfig?.endpointKey) {
        this._authConfigJson$ = this.appConfig
          .getConfigValue(this._oAuthConfig.app, this._oAuthConfig.endpointKey)
          .pipe(
            switchMap((url: string) => this.http.get<OauthAEMConfig>(url)),
            shareReplay(1)
          );
      } else {
        this._authConfigJson$ = this.userData
          .getAuthConfigContent()
          .pipe(shareReplay(1));
      }
    }
    return this._authConfigJson$;
  }
}
